import { render, staticRenderFns } from "./GuppyChatConversationList.vue?vue&type=template&id=b354afd8&"
import script from "./GuppyChatConversationList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatConversationList.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatConversationList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports